"use client";

import { DrawerContent } from "../drawer-content";
import { FloatingCorners } from "../floating-corner";
import { ModalContent, type ModalContentProps } from "../modal-content";

export type RuntimeProps = ModalContentProps;

export function Runtime({ hostId }: RuntimeProps) {
	return (
		<>
			<ModalContent hostId={hostId} />
			<DrawerContent hostId={hostId} slotId="drawer_left" />
			<DrawerContent hostId={hostId} slotId="drawer_right" />
			<FloatingCorners />
		</>
	);
}
